module.exports = __webpack_public_path__ + "static/img/404.446a492.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.gif
// module id = +2J0
// module chunks = 1